import styles from "./Nav.module.css";

type Props = {
  chibiEnabled: boolean;
  onToggleChibi: () => void;
};

const links = [
  { href: "#rifle", label: "Rifle" },
  { href: "#history", label: "History" },
  { href: "#dorm", label: "Dorm" },
  { href: "#archive", label: "Archive" },
  { href: "#art", label: "Visuals" },
  { href: "#sounds", label: "Sounds" },
];

export function Nav({ chibiEnabled, onToggleChibi }: Props) {
  return (
    <header className={styles.bar}>
      <a className={styles.brand} href="#top">
        <span className={styles.brandName}>MONDRAGÓN</span>
        <span className={styles.brandSub}>M1908 · Index 317</span>
      </a>
      <nav className={styles.links} aria-label="Sections">
        {links.map((link) => (
          <a key={link.href} href={link.href}>
            {link.label}
          </a>
        ))}
        <button
          type="button"
          className={styles.toggle}
          aria-pressed={chibiEnabled}
          onClick={onToggleChibi}
        >
          Chibi {chibiEnabled ? "on" : "off"}
        </button>
      </nav>
    </header>
  );
}
